import React from "react";
import { useTranslation } from "react-i18next";
import { legendStops, qualityLabelKey } from "../../../utils/netquality";
import styles from "../network_map.module.css";

export default function Legend({ metric, iface }) {
  const { t } = useTranslation();
  const stops = legendStops(metric, iface);
  return (
    <div className={styles.legend}>
      <div className={styles.legendTitle}>{t(`netmap.metrics.${metric}`)}</div>
      {stops.map((stop) => (
        <div key={stop.q} className={styles.legendRow}>
          <i className={styles.legendSwatch} style={{ background: stop.color }} />
          <span className={styles.legendLabel}>{t(qualityLabelKey(stop.q === 0 ? 0 : stop.q - 1))}</span>
          <span className={styles.legendValue}>{stop.label}</span>
        </div>
      ))}
    </div>
  );
}
